import React, { useState } from 'react';
import { Camera, Plus, X, Film, FileText, Upload } from 'lucide-react';
// import { Camera, Plus, X, Film, FileText, Upload } from 'lucide-react';
import styles from '../../pages/JobDashboard/JobDetailNew.module.css';

const JobFileUploader = ({ 
    currentFiles = [], 
    onFilesChange, 
    maxFiles = 4, 
    isReadOnly = false 
}) => {
    const [isDragging, setIsDragging] = useState(false);

    // const processFiles = (files) => {
    //     if (isReadOnly) return;

    //     const filesArray = Array.from(files);
    //     const remainingSlots = maxFiles - currentFiles.length;
        
    //     let actualFilesToUpload = filesArray;
    //     if (filesArray.length > remainingSlots) {
    //         alert(`You can only upload ${remainingSlots} more file(s). Max ${maxFiles} files allowed.`);
    //         actualFilesToUpload = filesArray.slice(0, remainingSlots);
    //     }

    //     // Validate size and create objects
    //     const newAttachments = [];
        
    //     actualFilesToUpload.forEach((file, index) => {
    //          const isVideo = file.type.startsWith('video/');
    //          const sizeLimit = isVideo ? 50 * 1024 * 1024 : 10 * 1024 * 1024; // 50MB video, 10MB others
             
    //          if (file.size > sizeLimit) {
    //              alert(`File ${file.name} is too large. Max ${isVideo ? '50MB' : '10MB'}.`);
    //              return;
    //          }

    //          newAttachments.push({ 
    //             key: `new-${Date.now()}-${index}-${Math.random()}`, 
    //             url: URL.createObjectURL(file), 
    //             file,
    //             type: file.type.startsWith('image/') ? 'image' : file.type.startsWith('video/') ? 'video' : 'document',
    //             isExisting: false
    //         });
    //     });

    //     if (newAttachments.length > 0) {
    //         onFilesChange([...currentFiles, ...newAttachments]);
    //     }
    // };

    const processFiles = (files) => {

        if (isReadOnly) return;

        const filesArray = Array.from(files);

        const remainingSlots = maxFiles - currentFiles.length;

        let actualFilesToUpload = filesArray;

        if (filesArray.length > remainingSlots) {

            alert(`You can only upload ${remainingSlots} more image(s). Max ${maxFiles} images allowed.`);

            actualFilesToUpload = filesArray.slice(0, remainingSlots);
        }

        const newAttachments = [];

        actualFilesToUpload.forEach((file, index) => {

            const allowedTypes = [
                'application/pdf',
                'application/msword',
                'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
                'video/mp4'
            ];

            const isImage = file.type.startsWith('image/');

            const isAllowed = isImage || allowedTypes.includes(file.type);

            if (!isAllowed) {

                alert(`${file.name} is not a supported file type.`);

                return;
            }

            const isVideo = file.type === 'video/mp4';

            const sizeLimit = isVideo
                ? 50 * 1024 * 1024
                : 10 * 1024 * 1024;

            if (file.size > sizeLimit) {

                alert(
                    `${file.name} is too large. Max ${isVideo ? '50MB' : '10MB'
                    }.`
                );

                return;
            }

            newAttachments.push({
                key: `new-${Date.now()}-${index}-${Math.random()}`,
                url: URL.createObjectURL(file),
                file,
                type: isImage
                    ? 'image'
                    : isVideo
                        ? 'video'
                        : 'document',
                isExisting: false
            });
        });

        if (newAttachments.length > 0) {

            onFilesChange([...currentFiles, ...newAttachments]);
        }
    };

    const handleFileUpload = (e) => {
        processFiles(e.target.files);
    };

    const handleDragOver = (e) => {
        e.preventDefault();
        if (!isReadOnly) setIsDragging(true);
    };

    const handleDragLeave = (e) => {
        e.preventDefault();
        setIsDragging(false);
    };

    const handleDrop = (e) => {
        e.preventDefault();
        setIsDragging(false);
        if (!isReadOnly && e.dataTransfer.files && e.dataTransfer.files.length > 0) {
            processFiles(e.dataTransfer.files);
            e.dataTransfer.clearData();
        }
    };

    const removeAttachment = (key) => {
        if (isReadOnly) return;
        
        const fileToRemove = currentFiles.find(f => f.key === key);
        if (fileToRemove && !fileToRemove.isExisting && fileToRemove.url && fileToRemove.url.startsWith('blob:')) {
            URL.revokeObjectURL(fileToRemove.url);
        }
        
        onFilesChange(currentFiles.filter(img => img.key !== key));
    };

    // Helper to determine type for existing files if not explicitly set
    // const getFileType = (fileObj) => {
    //     if (fileObj.type) return fileObj.type; // already set
        
    //     // Infer from URL or filename if possible
    //     const url = fileObj.url || '';
    //     const lower = url.toLowerCase();
    //     if (/\.(jpg|jpeg|png|gif|webp)$/.test(lower)) return 'image';
    //     if (/\.(mp4|webm|ogg|mov)$/.test(lower)) return 'video';
    //     if (/\.(pdf|doc|docx|xls|xlsx|csv|txt)$/.test(lower)) return 'document';
        
    //     // If it's an existing image from backend (usually assumes images for now in JobDetailNew)
    //     return 'image'; 
    // };
    
    const getFileType = (fileObj) => {

        if (fileObj.type) {
            return fileObj.type;
        }

        const url = (fileObj.url || '').toLowerCase();

        // Images
        if (
            /\.(jpg|jpeg|png|gif|webp|bmp|svg|avif)$/.test(url)
        ) {
            return 'image';
        }

        // Videos
        if (
            /\.(mp4)$/.test(url)
        ) {
            return 'video';
        }

        // Documents
        if (
            /\.(pdf|doc|docx)$/.test(url)
        ) {
            return 'document';
        }

        return 'document';
    };

    return (
        <div className={styles.jobDetailNew_card}>
            <div className={styles.jobDetailNew_cardHeader}>
                <h3 className={styles.jobDetailNew_cardTitle}>
                    <Camera className={`${styles.jobDetailNew_iconMd} ${styles.jobDetailNew_textAmber600}`} />
                    Job Files (Optional)
                </h3>
            </div>
            <div className={`${styles.jobDetailNew_cardContent} ${styles.jobDetailNew_cardContentSpaceY6}`}>
                <div>
                    <p className={styles.jobDetailNew_textGray600}>
                        Upload photos, videos, or documents to help professionals understand the job. <br/>
                        <span style={{fontSize:'0.85rem', color:'#9ca3af'}}>(Max {maxFiles} files. JPG, PNG, PDF, DOC, MP4 supported)</span>
                    </p>
                    
                    <div 
                        className={styles.jobDetailNew_uploadArea} 
                        style={{
                            marginTop: '1rem', 
                            borderColor: isDragging ? '#3b82f6' : undefined,
                            backgroundColor: isDragging ? '#eff6ff' : undefined,
                            transition: 'all 0.2s ease',
                            cursor: isReadOnly ? 'default' : 'pointer',
                            opacity: isReadOnly ? 0.7 : 1
                        }}
                        onDragOver={handleDragOver}
                        onDragLeave={handleDragLeave}
                        onDrop={handleDrop}
                    >
                        <Upload className={styles.jobDetailNew_uploadIcon} />
                        <label htmlFor="file-upload" className={`${styles.jobDetailNew_button} ${styles.jobDetailNew_buttonOutline}`} style={{cursor: isReadOnly ? 'default' : 'pointer', pointerEvents: isReadOnly ? 'none' : 'auto'}}>
                            <Plus size={16} style={{marginRight: '8px'}}/> Add Files
                        </label>
                        <input 
                            id="file-upload" 
                            type="file" 
                            multiple 
                            // accept="image/*,application/pdf,.doc,.docx,.xls,.xlsx,video/mp4,video/webm,video/quicktime" 
                            accept="image/*,.pdf,.doc,.docx,video/mp4" 
                            className="hidden" 
                            onChange={handleFileUpload} 
                            disabled={currentFiles.length >= maxFiles || isReadOnly} 
                        />
                         <p style={{marginTop: '0.5rem', fontSize: '0.8rem', color: '#6b7280'}}>
                            or drag and drop files here
                        </p>
                    </div>

                    {/* PREVIEW GRID */}
                    {currentFiles.length > 0 && (
                        <div className={styles.jobDetailNew_uploadedImagesGrid} style={{marginTop: '1.5rem', gridTemplateColumns: 'repeat(auto-fill, minmax(100px, 1fr))'}}>
                            {currentFiles.map(item => {
                                const itemType = getFileType(item);
                                return (
                                    <div key={item.key} className={styles.jobDetailNew_uploadedImageItem} style={{aspectRatio: '1', position:'relative'}}>
                                        
                                        {/* IMAGE PREVIEW */}
                                        {itemType === 'image' && (
                                            <img src={item.url} alt="preview" className={styles.jobDetailNew_uploadedImage} style={{width:'100%', height:'100%', objectFit:'cover'}} />
                                        )}

                                        {/* VIDEO PREVIEW */}
                                        {itemType === 'video' && (
                                            <div style={{width:'100%', height:'100%', backgroundColor:'#000', display:'flex', alignItems:'center', justifyContent:'center'}}>
                                                <video src={item.url} style={{width:'100%', height:'100%', objectFit:'cover'}} muted />
                                                <div style={{position:'absolute', zIndex:10, color:'white'}}><Film size={24}/></div>
                                            </div>
                                        )}

                                        {/* DOCUMENT PREVIEW */}
                                        {itemType === 'document' && (
                                            <div style={{width:'100%', height:'100%', display:'flex', flexDirection:'column', alignItems:'center', justifyContent:'center', backgroundColor:'#f3f4f6', padding:'5px'}}>
                                                <FileText size={32} color="#4b5563" />
                                                <span style={{fontSize:'10px', color:'#374151', marginTop:'5px', textAlign:'center', width:'100%', wordBreak:'break-all', lineHeight:'1.2'}}>
                                                    {item.file
                                                        ? item.file.name.slice(0, 15)
                                                        : item.url?.split('.').pop()?.toUpperCase() || 'DOCUMENT'}
                                                    {item.file && item.file.name.length > 15 && '...'}
                                                </span>
                                            </div>
                                        )}

                                        {/* REMOVE BUTTON */}
                                        {!isReadOnly && (
                                            <button onClick={() => removeAttachment(item.key)} className={`${styles.jobDetailNew_button} ${styles.jobDetailNew_imageRemoveBtn}`}>
                                                <X className={styles.jobDetailNew_buttonIcon} />
                                            </button>
                                        )}
                                    </div>
                                );
                            })}
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

export default JobFileUploader;
